var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRapidoFreeScan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.001,
    height: 128,
    viewBox: "0 0 128.001 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-scan-4370407",
    transform: "translate(-69.998 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M75.333,0A5.333,5.333,0,0,0,70,5.333V34.668H80.667v-24h24V0Z",
    transform: "translate(-0.002 -0.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M478.327,10.664h24v24h10.667V5.329A5.333,5.333,0,0,0,507.661,0H478.326Z",
    transform: "translate(-314.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M80.666,408.327v24h24v10.667H75.331A5.333,5.333,0,0,1,70,437.661V408.326Z",
    transform: "translate(0 -314.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M502.33,408.327v24h-24v10.667h29.335A5.333,5.333,0,0,0,513,437.661V408.326Z",
    transform: "translate(-314.999 -314.998)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M243.975,117.052a5.328,5.328,0,0,0-3.961,0l-26.667,10.667a5.332,5.332,0,0,0-3.353,4.952v32a5.333,5.333,0,0,0,3.353,4.952l26.667,10.667a5.337,5.337,0,0,0,3.961,0l26.667-10.667a5.333,5.333,0,0,0,3.353-4.952v-32a5.332,5.332,0,0,0-3.353-4.952Zm-7.313,29.895-16-6.4v20.512l16,6.4Zm26.665,14.112-16,6.4V146.947l16-6.4ZM254.3,132.67l-12.306,4.922-12.306-4.922,12.306-4.923Z",
    transform: "translate(-107.997 -84.674)",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapidoFreeScan);
export default __webpack_public_path__ + "static/media/rapidoFreeScan.22a7e94b25dd0e9a0f46783499a20355.svg";
export { ForwardRef as ReactComponent };